import { DefaultRootState } from '~/types'
import { getUserIdentity } from '~/redux-modules/identity'
import isFlagEnabled from '~/lib/isFlagEnabled'
import getFlagValue from '~/lib/getFlagValue'

export const selectFlags = (state: DefaultRootState) => {
    const identity = getUserIdentity(state)

    return {
        showMaintenanceNotice: isFlagEnabled(
            identity,
            'MAINTENANCE_NOTICE_TOGGLE',
            'true',
        ),
        maintenanceNoticeDateTimeStart: getFlagValue(
            identity,
            'MAINTENANCE_NOTICE_DATETIME_START',
        ),
        maintenanceNoticeDateTimeEnd: getFlagValue(
            identity,
            'MAINTENANCE_NOTICE_DATETIME_END',
        ),
        additionalNoticeMessage: getFlagValue(
            identity,
            'ADDITIONAL_NOTICE_MESSAGE',
        ),
        showAdditionalNotice: isFlagEnabled(
            identity,
            'ADDITIONAL_NOTICE_TOGGLE',
            'true',
        ),
    }
}
